import React, { Component } from 'react';
import { Guardian } from '@xaamin/guardian';
import { Dropdown, ButtonGroup } from 'react-bootstrap';

import { connect } from 'shalala';
import { Http } from '../../../../../support';
import { useStore } from '../../../../../store';
import LoadingButton from '../../../../../facturotopia/LoadingButton';

class CancelacionesItemActions extends Component {
  handleOnDownloadActionClick = async () => {
    const { selectedRowKeys } = this.props;

    await this.props.download(selectedRowKeys);
  };

  handleOnDownloadOriginalFile = async () => {
    try {
      const response = await Http.get(`${window.BONJOUR_URL}/api/excel-files/${this.props.selectedRows[0].id}`, {
        responseType: 'blob',
      });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar el archivo original',
      });
    }
  };

  render() {
    const { alignRight, selectedRowKeys } = this.props;
    const { actionBusy: busy } = this.props;

    return (
      <>
        {Guardian.allows('cancelacion.masiva.descargar.excel.procesado') && (
          <Dropdown
            as={ButtonGroup}
            alignRight={alignRight}
          >
            {selectedRowKeys.length === 1 && (
              <LoadingButton
                variant="secondary"
                loading={busy}
                onClick={this.handleOnDownloadActionClick}
              >
                {busy === true ? 'Descargando' : 'Descargar'}
              </LoadingButton>
            )}

            {selectedRowKeys.length === 1 && (
              <>
                <Dropdown.Toggle
                  split
                  variant="secondary"
                  id="dropdown-split-basic"
                />

                {Guardian.allows('cancelacion.masiva.descargar.archivo.original') && (
                  <Dropdown.Menu>
                    <Dropdown.Item
                      as="div"
                      onClick={this.handleOnDownloadOriginalFile.bind(this)}
                    >
                      Descargar original
                    </Dropdown.Item>
                  </Dropdown.Menu>
                )}
              </>
            )}

            {/* <Dropdown.Menu>
              <Dropdown.Item as="div" onClick={ this.handleOnDownloadActionClick.bind(this, 'zip') }>Cancelar procesamiento</Dropdown.Item>
            </Dropdown.Menu> */}
          </Dropdown>
        )}
      </>
    );
  }
}

const mapState = (store) => {
  return {
    actionBusy: store.modulo.cancelaciones.archivos.actionBusy,
  };
};

const mapActions = (actions) => {
  return { download: actions.modulo.cancelaciones.archivos.download };
};

export default connect(useStore, mapState, mapActions)(CancelacionesItemActions);
